import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const resp = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, message }),
    });

    const data = await resp.json();
    if (!resp.ok) {
      alert(data?.error || "Hata");
      return;
    }

    clearState();
    alert(`Mesaj alındı ✅ (kalan: ${data.remainingToday})`);
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>BİZİMLE İLETİŞİME GEÇEBİLİRSİNİZ</h2>
                <p>
                  Lütfen aşağıdaki formu doldurarak bize e-posta gönderin. En
                  kısa sürede size geri dönüş yapacağız.
                </p>
              </div>
              <form name="sentMessage " validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group ">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="İsim Soyisim"
                        required
                        onChange={handleChange}
                         style={{ "border-radius": "16px" }}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                         style={{ "border-radius": "16px" }}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mesaj"
                    required
                    onChange={handleChange}
                    style={{ "border-radius": "16px" }}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Gönder
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>İletişim Bilgilerimiz</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Adres
                </span>

                {props.data ? (
                  <a
                    className="address-link"
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      props.data.address
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "6px" }}
                  >
                    {props.data.address}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Satış Telefon
                </span>{" "}
                {props.data ? (
                  <a href={`tel:${props.data.phone}`} className="phone-link">
                    {props.data.phone}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Teknik Servis Telefon
                </span>{" "}
                {props.data ? (
                  <a href={`tel:${props.data.tphone}`} className="phone-link">
                    {props.data.tphone}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-message"></i> Email
                </span>{" "}
                {props.data ? (
                  <a href={`mailto:${props.data.email}`} className="email-link">
                    {props.data.email}
                  </a>
                ) : (
                  "loading"
                )}
              </p>
            </div>
          </div>
          {/*<div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Tomedyus Medikal{" "}
            <a href="http://tomedyus.com" rel="nofollow">
              tomedyus.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
